import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=48d148bc&scoped=true&"
import script from "./SectionContainer.vue?vue&type=script&lang=js&"
export * from "./SectionContainer.vue?vue&type=script&lang=js&"
import style0 from "./SectionContainer.vue?vue&type=style&index=0&id=48d148bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d148bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VSheet})
